import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FilterContextType {
  showFilter: boolean;
  filterData: {
    subjects: string[];
    chapters: string[];
    activeSubject: string;
    activeChapter: string;
    activeDifficulty: string;
    questionCount: number;
    totalQuestions: number;
    onSubjectChange: (subject: string) => void;
    onChapterChange: (chapter: string) => void;
    onDifficultyChange: (difficulty: string) => void;
  } | null;
  setShowFilter: (show: boolean) => void;
  setFilterData: (data: any) => void;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilter must be used within FilterProvider');
  }
  return context;
};

export const FilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);

  return (
    <FilterContext.Provider value={{ showFilter, filterData, setShowFilter, setFilterData }}>
      {children}
    </FilterContext.Provider>
  );
};